import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "John Doe",
        title: "Co-Founder & CEO",
        biography: "John Doe is a visionary leader and co-founder with a passion for innovation and excellence. With years of executive experience, he drives strategic growth and fosters a culture of integrity and collaboration. Under his leadership, the company continues to thrive and exceed industry standards.",
        contacts: {
            phone: "222-333-4455",
            email: "john.doe@example.com",
            website: "www.johndoe.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Business Strategist",
            "Operations Director",
            "Executive Consultant",
            "Co-Founder & CEO",
            "Innovation Leader"
        ],
        skills: [
            { id: 1, title: "Leadership", progress: 98 },
            { id: 2, title: "Strategic Planning", progress: 95 },
            { id: 3, title: "Business Development", progress: 92 }
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Jane Smith",
        title: "Co-Founder & CTO",
        biography: "Jane Smith is a tech visionary and the driving force behind the company’s innovative solutions. As Co-Founder & CTO, she brings a wealth of knowledge in system architecture, product development, and emerging technologies. Her leadership ensures the company remains at the forefront of digital transformation.",
        contacts: {
            phone: "333-444-5566",
            email: "jane.smith@example.com",
            website: "www.janesmith.com"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Software Engineer",
            "Tech Lead",
            "Product Architect",
            "Co-Founder & CTO",
            "Innovation Strategist"
        ],
        skills: [
            { id: 1, title: "Software Architecture", progress: 96 },
            { id: 2, title: "Cloud Engineering", progress: 93 },
            { id: 3, title: "AI & Automation", progress: 90 }
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Michael Brown",
        title: "Lead Developer",
        biography: "Michael Brown is a skilled and passionate developer leading the development team with precision and innovation. With years of hands-on experience in coding, debugging, and deploying scalable applications, he ensures the technical excellence of every project.",
        contacts: {
            phone: "444-555-6677",
            email: "michael.brown@example.com",
            website: "www.michaelbrown.dev"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Frontend Developer",
            "Backend Engineer",
            "Full Stack Developer",
            "Lead Developer",
            "DevOps Specialist"
        ],
        skills: [
            { id: 1, title: "JavaScript & Frameworks", progress: 95 },
            { id: 2, title: "API Integration", progress: 92 },
            { id: 3, title: "DevOps & CI/CD", progress: 89 }
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Emily White",
        title: "Data Scientist",
        biography: "Emily White is a data-driven expert who transforms complex datasets into actionable insights. Her expertise in machine learning, predictive analytics, and data visualization empowers teams to make informed decisions backed by solid evidence.",
        contacts: {
            phone: "555-666-7788",
            email: "emily.white@example.com",
            website: "www.emilywhite.ai"
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        experience: [
            "Data Analyst",
            "Machine Learning Engineer",
            "Business Intelligence Expert",
            "Data Scientist",
            "AI Researcher"
        ],
        skills: [
            { id: 1, title: "Data Analysis", progress: 94 },
            { id: 2, title: "Machine Learning", progress: 91 },
            { id: 3, title: "Data Visualization", progress: 89 }
        ]
    }

];

export default team;